// INSIDO (13-polish-estrutura): "cargo" (job title) of a member inside an
// Organization = the name of their highest-ranked upstream server role.
// Shared by the message row badge, the members panel and the feed.
import type { ServerMember } from "stoat.js";

export interface MemberRoleLabel {
  /** Role name, e.g. "Fundadora" */
  name: string;
  /** Role colour (CSS value) when the role defines one */
  colour?: string;
}

/**
 * Highest-ranked role of a member, or undefined when they have none.
 * @param member Server member (may be undefined while loading)
 */
export function memberRoleLabel(
  member: ServerMember | null | undefined,
): MemberRoleLabel | undefined {
  // stoat.js `orderedRoles` goes from lowest to highest priority, so the
  // highest-ranked role is the last entry.
  const roles = member?.orderedRoles;
  const role = roles?.[roles.length - 1];
  if (!role?.name) return undefined;
  const colour = role.colour ?? member?.roleColour ?? undefined;
  return colour ? { name: role.name, colour } : { name: role.name };
}
